import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const ServiceIntroMain = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname;

  const navItems = [
    { path: "/service-provide/voucher-aicc", label: "문자콜센터 서비스" },
    { path: "/service-provide/messaging", label: "메시징 서비스" },
  ];

  useEffect(() => {
    if (currentPath === "/service-provide") {
      navigate("/service-provide/messaging", { replace: true });
    }
  }, [currentPath, navigate]);

  if (currentPath === "/service-provide") return null;

  return (
    <div className="w-full max-w-full py-8 bg-gradient-to-l mt-36">
      <section className="flex flex-col items-start justify-between mx-auto border-b max-w-container about:flex-row about:items-end">
        <div className="hidden sm:block mb-6 text-black about:mb-[2rem] px-[2rem] wide:px-0">
          <h1
            className="text-left leading-[1.3] flex flex-col"
            style={{ fontSize: "var(--font-display-large, 5rem)", fontWeight: 700 }}
          >
            <span className="text-[2.2rem] font-medium ">서비스 소개</span>
            <span className="text-[4rem] font-bold">
              {navItems.find(item => item.path === currentPath)?.label}
            </span>
          </h1>
        </div>

        {/* 오른쪽 탭 네비게이션 영역: 모바일에서도 계속 유지 */}
        <nav aria-label="서비스 소개 메뉴" className="w-full about:w-auto">
          <ul className="flex items-center m-0 list-none gap-8 about:gap-10 px-[2rem] wide:px-0">
            {navItems.map(item => (
              <li key={item.path} className="flex whitespace-nowrap">
                <Link
                  to={item.path}
                  className="relative inline-block pb-4 transition-colors"
                  style={{
                    fontSize: "var(--font-title-medium, 1.8rem)",
                    color: currentPath === item.path ? "#032C6D" : "#888",
                    fontWeight: currentPath === item.path ? 700 : 400,
                    textDecoration: "none",
                  }}
                >
                  {item.label}
                  <span
                    className="absolute left-0 bottom-0 h-[2px] bg-[#032C6D] transition-all duration-300"
                    style={{
                      width: currentPath === item.path ? "100%" : "0",
                    }}
                  />
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </section>
    </div>
  );
};

export default ServiceIntroMain;
